import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedCareerPathwaysExploreRoleRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model(params: Record<string, unknown>) {
    const role_id = params['role_id'] as string;
    const [role, pathways] = await Promise.all([
      this.reimaginedData.fetchCareerRole(role_id),
      this.reimaginedData.fetchRolePathways(role_id),
    ]);

    return {
      role,
      pathways,
    };
  }
}
